import { useEffect, useState, lazy, Suspense } from "react";
import "styles/globalStyles.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useCartContext } from "context/UseCartContext.js";
import { login } from "./api/LoginApi.js";
import {
  // getHeaderConfig,
  setBearerToken,
  setBranchId,
} from "./utility/HeaderConfig.js";
import { branchdetails } from "api/BranchDetailsApi";
import { getBranchId, setCorporateId } from "utility/HeaderConfig";
import ScrollToTop from "utility/ScrollToTop.js";
import { CategoryProvider } from "./components/CategoryProvider.js";
import SkeletonLoader from "components/SkeletonLoader.js";
// import Header from "components/headers/header.js";

const Header = lazy(() => import("./components/headers/header.js"));
const Footer = lazy(() => import("./components/footers/footer.js"));
const OrderStatusInfo = lazy(() => import("./pages/OrderStatusInfo.js"));
const TechWallet = lazy(() => import("./components/TechWallet.js"));
const ViewAddress = lazy(() => import("./components/ViewAddress.js"));
const AddAddress = lazy(() => import("./components/AddAddress.js"));
const MyPurchase = lazy(() => import("./components/MyPurchase.js"));
const VelSeriesDetails = lazy(() => import("./components/VelSeriesDetails.js"));
const OccasionCategoriesComponent = lazy(
  () => import("./components/OccasionCategoriesComponent.js"),
);
const ShopOurExclusiveComponent = lazy(
  () => import("./components/ShopOurExclusiveComponent.js"),
);
const TrendOnShopComponent = lazy(
  () => import("./components/TrendOnShopComponent.js"),
);
const BestSellingComponent = lazy(
  () => import("./components/BestSellingComponent.js"),
);
const AppStoreQR = lazy(() => import("./components/footers/AppStoreQR.js"));
const MyScheme = lazy(() => import("./pages/MyScheme.js"));
const ProductList = lazy(() => import("./pages/ProductList.js"));
const ProductDetails = lazy(() => import("./pages/ProductDetails.js"));
const VelProductDetails = lazy(() => import("./pages/VelProductDetails.js"));
const About = lazy(() => import("./pages/About.js"));
const JoinScheme = lazy(() => import("./pages/JoinScheme.js"));
const WishList = lazy(() => import("./pages/WishList.js"));
const MostLiked = lazy(() => import("./pages/MostLiked.js"));
const NewArrivals = lazy(() => import("./pages/NewArrivals.js"));
const BookAnAppointment = lazy(() => import("./pages/BookAnAppointment.js"));
const Offers = lazy(() => import("./pages/Offers.js"));
const CartPage = lazy(() => import("./pages/CartPage.js"));
const CheckoutPage = lazy(() => import("./pages/CheckoutPage.js"));
const Contact = lazy(() => import("./pages/Contact.js"));
const TermsConditions = lazy(() => import("./pages/Policies/TermsConditions"));
const PrivacyPolicy = lazy(() => import("./pages/Policies/PrivacyPolicy"));
const ShippingPolicy = lazy(() => import("./pages/Policies/ShippingPolicy"));
const RefundPolicy = lazy(() => import("./pages/Policies/RefundPolicy"));
const MainLandingPage = lazy(() => import("./MainLandingPage"));

export default function App() {
  //eslint-disable-next-line
  const [token, setToken] = useState(false);
  const [isAuthLoading, setIsAuthLoading] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [branch, setBranch] = useState({});
  //eslint-disable-next-line
  const [configImages] = useState(
    JSON.parse(
      '{"PGIMAGES": [{"key": "paymentGatway", "value": "https://images.prod-rasiinfotech.in/ecomm/paymentGatway.png"}], "STORIMAGES": [{"key": "store1", "value": "https://images.prod-rasiinfotech.in/ecomm/jewelleryShop1.jpg"}, {"key": "store2", "value": "https://images.prod-rasiinfotech.in/ecomm/jewelleryShop2.jpg"}], "MOBILE_APP_QR": [{"key": "qrCode", "value": "https://images.prod-rasiinfotech.in/ecomm/downloadApps.png"}], "E_COMMERCE_BANNERS": [{"key": "cart", "value": "https://images.prod-rasiinfotech.in/ecomm/cart.png"}, {"key": "enquiry", "value": "https://images.prod-rasiinfotech.in/ecomm/enquiry.png"}, {"key": "joinScheme", "value": "https://images.prod-rasiinfotech.in/ecomm/joinScheme.png"}, {"key": "mostLiked", "value": "https://images.prod-rasiinfotech.in/ecomm/mostLiked.webp"}, {"key": "newArrivals", "value": "https://images.prod-rasiinfotech.in/ecomm/newArrivals.webp"}, {"key": "offer", "value": "https://images.prod-rasiinfotech.in/ecomm/offer.png"}, {"key": "privacyPolicy", "value": "https://images.prod-rasiinfotech.in/ecomm/privacyPolicy.png"}, {"key": "productDetails", "value": "https://images.prod-rasiinfotech.in/ecomm/productDetails.png"}, {"key": "productList", "value": "https://images.prod-rasiinfotech.in/ecomm/productList.png"}, {"key": "refundPolicy", "value": "https://images.prod-rasiinfotech.in/ecomm/refundPolicy.png"}, {"key": "savingScheme", "value": "https://images.prod-rasiinfotech.in/ecomm/savingScheme.png"}, {"key": "schemeDetails", "value": "https://images.prod-rasiinfotech.in/ecomm/schemeDetails.png"}, {"key": "shippingPolicy", "value": "https://images.prod-rasiinfotech.in/ecomm/shippingPolicy.png"}, {"key": "termsConditions", "value": "https://images.prod-rasiinfotech.in/ecomm/termsConditions.png"}, {"key": "whishList", "value": "https://images.prod-rasiinfotech.in/ecomm/whishList.png"}, {"key": "paymentGatway", "value": "https://images.prod-rasiinfotech.in/ecomm/paymentGatway.webp"}, {"key": "contact", "value": "https://images.prod-rasiinfotech.in/ecomm/contact.png"},{"key": "referral", "value": "https://images.prod-rasiinfotech.in/ecomm/whishList.png"}]}',
    ),
  );

  const { branchId } = useCartContext();
  const helmetContext = {};

  // Show button when page is scorlled upto given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the top cordinate to 0
  // make scrolling smooth
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    initialAuth();
    window.addEventListener("scroll", toggleVisibility);
    //eslint-disable-next-line
  }, []);

  const initialAuth = () => {
    const loginDetails = {
      username: "ONLINEPAYMENT",
      password: "Payment@123",
    };
    const responseData = login(JSON.stringify(loginDetails));
    responseData
      .then((data) => {
        if (
          data &&
          data.authStatus &&
          data.authStatus.toLowerCase() === "success"
        ) {
          if (data.token) {
            setBearerToken(data.token);
            setBranchId(data.branches[0]);
            setToken(true);
            branchDetails();
          }
        }
        setIsAuthLoading(false);
      })
      .catch(() => {
        setIsAuthLoading(false);
      });
  };

  useEffect(() => {
    branchDetails();
  }, [branchId]);

  const branchDetails = () => {
    branchdetails(getBranchId()).then((data) => {
      setBranch(data.response);
      setCorporateId(data.response.storeDetails);
    });
  };

  if (isAuthLoading) {
    return (
      <div style={{ minHeight: "100vh" }}>
        <SkeletonLoader />
      </div>
    );
  }

  return (
    <>
      <HelmetProvider context={helmetContext}>
        {token ? (
          <Router>
            <CategoryProvider />
            <ScrollToTop />
            <Suspense
              fallback={
                <div
                  style={{
                    height: "80px",
                    backgroundColor: "#ffffff",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                />
              }
            >
              <Header branch={branch} />
            </Suspense>
            <Routes>
              <Route
                path="/orderInfo"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <OrderStatusInfo />
                  </Suspense>
                }
              />
              <Route
                path="/QRCode"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <AppStoreQR />
                  </Suspense>
                }
              />
              <Route
                path="/MyScheme"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <MyScheme />
                  </Suspense>
                }
              />
              <Route
                path="/ProductList"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <ProductList configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/ProductDetails/:id"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <ProductDetails
                      branch={branch}
                      configImages={configImages}
                    />
                  </Suspense>
                }
              />
              <Route
                path="/VelProductDetails/:id"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <VelProductDetails
                      branch={branch}
                      configImages={configImages}
                    />
                  </Suspense>
                }
              />
              <Route
                path="/About"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <About branch={branch} />
                  </Suspense>
                }
              />
              <Route
                path="/JoinScheme"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <JoinScheme configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/WishList"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <WishList configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/MostLiked"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <MostLiked configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/NewArrivals"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <NewArrivals configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/BookAnAppointment"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <BookAnAppointment configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/Offers"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <Offers configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/CartPage"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <CartPage configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/CheckoutPage"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <CheckoutPage />
                  </Suspense>
                }
              />
              <Route
                path="/Contact"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <Contact configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/TermsConditions"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <TermsConditions
                      branch={branch}
                      configImages={configImages}
                    />
                  </Suspense>
                }
              />
              <Route
                path="/PrivacyPolicy"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <PrivacyPolicy
                      branch={branch}
                      configImages={configImages}
                    />
                  </Suspense>
                }
              />
              <Route
                path="/ShippingPolicy"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <ShippingPolicy
                      branch={branch}
                      configImages={configImages}
                    />
                  </Suspense>
                }
              />
              <Route
                path="/RefundPolicy"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <RefundPolicy branch={branch} configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/BestSellingComponent"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <BestSellingComponent configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/TrendOnShopComponent"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <TrendOnShopComponent configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/ShopOurExclusiveComponent"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <ShopOurExclusiveComponent configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/OccasionCategoriesComponent"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <OccasionCategoriesComponent configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/VelSeriesDetails"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <VelSeriesDetails configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/MyPurchase"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <MyPurchase configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/AddAddress"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <AddAddress configImages={configImages} />
                  </Suspense>
                }
              />
              <Route
                path="/ViewAddress"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <ViewAddress />
                  </Suspense>
                }
              />
              <Route
                path="/TechWallet"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <TechWallet configImages={configImages} branch={branch} />
                  </Suspense>
                }
              />
              <Route
                path="/"
                element={
                  <Suspense fallback={<SkeletonLoader />}>
                    <MainLandingPage />
                  </Suspense>
                }
              />
            </Routes>
            <Suspense fallback={<SkeletonLoader />}>
              <Footer branch={branch} configImages={configImages} />
            </Suspense>
          </Router>
        ) : (
          <div className="position-absolute top-50 start-50 translate-middle">
            <p>Unable to connect. Please refresh the page.</p>
          </div>
        )}

        <div className="scroll-to-top position-fixed  bottom-0 end-0 m-4">
          {isVisible && (
            <div
              onClick={scrollToTop}
              className="rounded-circle hoverEffect"
              style={{ cursor: "pointer" }}
            >
              <i
                className="bi bi-arrow-up-short px-2 fs-2"
                style={{ fontSize: "20px" }}
              ></i>
            </div>
          )}
        </div>
      </HelmetProvider>
    </>
  );
}
